/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {get, post} from 'utils/axios/index'
import ApiResponse from 'models/ApiResponse'
import {AxiosError} from 'axios'
import {toast} from 'react-toastify'
import {handleRejectedErrorMsg} from 'utils/helpers/handleError'

export const getApiCall = async (
 url: string,
 params: any
) => {
 try {
  const res = await get<ApiResponse<any>>(url, params)
  if (res.success) {
   return res.data
  } else {
   toast.error(res.message)
   return null
  }
 } catch (err) {
  const e = err as AxiosError
  handleRejectedErrorMsg(e)
  return null
 }
}

export const postApiCall = async (
 url: string,
 filters: any
) => {
 try {
  const res = await post<ApiResponse<any>>(url, filters)
  if (res.success) {
   return res.data
  } else {
   toast.error(res.message)
   return null
  }
 } catch (err) {
  const e = err as AxiosError
  handleRejectedErrorMsg(e)
  return null
 }
}

export const downloadFileFromUrl = async (
 url: string,
 filename: string
) => {
 console.log('filename', filename)
 try {
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
 } catch (error) {
  console.error('Download error:', error)
 }
}
